import type { SectionProps } from "../types";

const roadmapSteps = [
  {
    title: "Nền tảng",
    description:
      "Xây dựng nền tảng tư duy công nghệ và logic hệ thống Tư duy thuật toán, dữ liệu, lập trình, và cách tiếp cận bài toán trong AI & phần mềm.",
    icon: "ri-seedling-line",
    align: "left",
  },
  {
    title: "Thực hành",
    description:
      "Thực hành trên các bài toán công nghệ và AI thực tế Áp dụng kiến thức vào lập trình, xử lý dữ liệu, mô hình AI và các tình huống doanh nghiệp.",
    icon: "ri-tools-line",
    align: "right",
  },
  {
    title: "Dự án",
    description:
      "Triển khai dự án công nghệ & AI theo mô hình thực tế Làm việc cùng mentor, xây dựng sản phẩm từ dữ liệu, hệ thống đến ứng dụng hoàn chỉnh.",
    icon: "ri-rocket-line",
    align: "left",
  },
  {
    title: "Sẵn sàng đi làm",
    description:
      "Sẵn sàng gia nhập lực lượng lao động công nghệ Hoàn thiện hồ sơ nghề nghiệp, luyện phỏng vấn và kết nối với doanh nghiệp công nghệ & AI.",
    icon: "ri-briefcase-4-line",
    align: "right",
  },
];

export default function RoadmapSection({ isVisible, sectionRef }: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="roadmap"
      className="py-16 sm:py-20 md:py-24 bg-white"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-10 sm:mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#2a4b7c] mb-3 sm:mb-4 px-4">
            Lộ trình bứt phá
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Hành trình biến bạn từ người mới bắt đầu thành kỹ sư chuyên nghiệp.
          </p>
        </div>

        <div className="relative">
          {/* Vertical line - Left on mobile, center on desktop */}
          <div className="absolute left-8 md:left-1/2 md:transform md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-cyan-400/30"></div>

          <div className="space-y-12 sm:space-y-16 md:space-y-24">
            {roadmapSteps.map((step, index) => (
              <div
                key={index}
                className={`relative transition-all duration-1000 ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-12"
                }`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                {/* Mobile Layout: Icon left, content right */}
                <div className="md:hidden flex gap-4 sm:gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 bg-cyan-500 rounded-full flex items-center justify-center shadow-lg relative z-10">
                      <i className={`${step.icon} text-white text-lg sm:text-xl`}></i>
                    </div>
                  </div>
                  <div className="flex-1 pt-1">
                    <h3 className="text-base sm:text-lg font-bold text-[#2a4b7c] mb-2">
                      {step.title}
                    </h3>
                    <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Desktop Layout: Alternating left/right */}
                <div className="hidden md:grid md:grid-cols-2 gap-8 items-center">
                  {step.align === "left" ? (
                    <>
                      <div className="text-right pr-12 lg:pr-16">
                        <h3 className="text-xl lg:text-2xl font-bold text-[#2a4b7c] mb-3">
                          {step.title}
                        </h3>
                        <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                      <div></div>
                    </>
                  ) : (
                    <>
                      <div></div>
                      <div className="pl-12 lg:pl-16">
                        <h3 className="text-xl lg:text-2xl font-bold text-[#2a4b7c] mb-3">
                          {step.title}
                        </h3>
                        <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </>
                  )}
                </div>

                {/* Desktop Center Icon */}
                <div
                  className={`hidden md:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-14 h-14 lg:w-16 lg:h-16 bg-cyan-500 rounded-full items-center justify-center shadow-lg z-10 transition-all duration-1000 ${
                    isVisible ? "scale-100" : "scale-0"
                  }`}
                  style={{ transitionDelay: `${index * 200}ms` }}
                >
                  <i className={`${step.icon} text-white text-xl lg:text-2xl`}></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

